<template>
  <el-form
    label-position="top"
    ref="familiesForm"
    :model="familiesForm"
    :rules="familiesFormRules"
    @submit.native.prevent="submit('familiesForm', familiesForm)"
  >
    <el-row :gutter="15" style="margin-bottom: 10px;">
      <el-col :span="8">
        <span>* Nombre completo</span>
      </el-col>
      <el-col :span="4">
        <span>Teléfono</span>
      </el-col>
      <el-col :span="4">
        <span>Fecha de Nac.</span>
      </el-col>
      <el-col :span="5">
        <span>* Parentesco</span>
      </el-col>
    </el-row>
    <el-row :gutter="15" v-for="(item, i) in familiesForm.items" :key="i">
      <el-col :span="8">
        <el-form-item
          :prop="`items.${i}.name`"
          :rules="[familiesFormRules.required]"
        >
          <el-input
            size="small"
            v-model="item.name"
            placeholder="Nombre del familiar"
          />
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item :prop="`items.${i}.phone`">
          <el-input size="small" v-model="item.phone" placeholder="Telefono" />
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item :prop="`items.${i}.dob`">
          <el-input
            size="small"
            v-model="item.dob"
            placeholder="DD/MM/YYYY"
            autocomplete="off"
            clearable
            prefix-icon="el-icon-date"
            v-mask="'##/##/####'"
          />
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item
          :prop="`items.${i}.relationship`"
          :rules="[familiesFormRules.required]"
        >
          <el-select
            filterable
            clearable
            class="w-full"
            size="small"
            v-model="item.relationship"
            placeholder="Selecciona la relación"
          >
            <el-option
              v-for="relationship in relationships"
              :key="relationship.id"
              :label="relationship.name"
              :value="relationship.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-row :gutter="5">
          <el-col
            :span="familiesForm.items.length > i + 1 ? 24 : 12"
            v-if="familiesForm.items.length > 1"
          >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              class="w-full"
              style="margin-top: 5px;"
              v-if="familiesForm.items.length > 1"
              @click="removeFamily(i)"
            />
          </el-col>
          <el-col
            :span="familiesForm.items.length == 1 ? 24 : 12"
            v-if="familiesForm.items.length == i + 1"
          >
            <el-button
              type="success"
              icon="el-icon-plus"
              size="small"
              class="w-full"
              style="margin-top: 5px;"
              @click="addNewFamily()"
            />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="24" class="flex justify-end">
        <el-button size="small" @click="$emit('cancel')">Cancelar</el-button>
        <el-button size="small" type="primary" native-type="submit"
          >Guardar</el-button
        >
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import dfn from "date-fns";

export default {
  name: "DialogFamilies",
  props: ["employeeID", "values", "relationships"],
  data() {
    return {
      familiesForm: {
        items: [
          {
            relationship: "",
            name: "",
            phone: "",
            dob: null,
          },
        ],
      },
      familiesFormRules: {
        required: {
          required: true,
          message: "Campo requerido",
          trigger: "change",
        },
      },
    };
  },
  methods: {
    addNewFamily() {
      this.familiesForm.items.push({
        relationship: "",
        name: "",
        phone: "",
        dob: null,
      });
    },
    removeFamily(index) {
      this.familiesForm.items.splice(index, 1);
    },
    submit(formName, familiesForm) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }

        this.$confirm(
          "¿Estás seguro que deseas actualizar estos datos?",
          "Confirmación",
          {
            confirmButtonText: "Si, actualizar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        )
          .then(() => {
            let families = "";
            for (const d of familiesForm.items) {
              const phone = R.isEmpty(d.phone) ? null : `"${d.phone}"`;
              const dob = R.isNil(d.dob) ? null : `"${d.dob}"`;

              families += `{
                name: "${d.name}",
                phone: ${phone},
                relationship: "${d.relationship}",
                dob: ${dob},
              }`;
            }
            axios
              .post("/", {
                query: `mutation {
                  employeeManageFamilies(
                    where: { id:"${this.employeeID}" },
                    families: [${families}]
                  )
                  { id }
                }`,
              })
              .then((res) => {
                this.$notify({
                  title: "Éxito",
                  message: "Se ha actualizado la información correctamente.",
                  type: "success",
                });
                this.$emit("save", true);
              })
              .catch(console.log);
          })
          .catch((this.saving = false));
      });
    },
  },
  mounted() {
    if (!R.isEmpty(this.values)) {
      this.familiesForm.items = this.values;
    }
  },
  updated() {
    if (!R.isEmpty(this.values)) {
      this.familiesForm.items = this.values;
    }
  },
};
</script>
